import type {
  AdditionalService,
  FindFlightOffersFlightSegmentV3,
  FindFlightOffersFlightV3,
  FindFlightOffersOfferFlightsOverviewV3,
  FindFlightOffersOfferV3,
  GetFlightAvailabilityTokenBodyInputDto,
  PackageBannerV3,
} from "@/types/codegen";
import type { SortValue } from "@/types/types";

export type AdditionalServiceData = {
  service: AdditionalService;
  categoryCode: string;
  flightDirection?: "departure" | "return";
  mandatory: boolean;
  freeOption?: boolean;
};

export type ServicesSelection = Pick<
  GetFlightAvailabilityTokenBodyInputDto,
  "mandatoryServices" | "optionalServices"
>;

export type FlightType = FindFlightOffersFlightV3 & {
  segments: FindFlightOffersFlightSegmentV3[];
};

export type MappedFlightOffer = Omit<
  FindFlightOffersOfferV3,
  "flightsOverview"
> & {
  flightsOverview: (FindFlightOffersOfferFlightsOverviewV3 & {
    departureFlight: FlightType;
    returnFlight?: FlightType;
  })[];
  searchResultToken: string;
};

export type FullOfferType = MappedFlightOffer | PackageBannerV3;

export type FlightOffer = Pick<
  FindFlightOffersOfferV3,
  | "index"
  | "searchResultKey"
  | "offerItems"
  | "totalPrice"
  | "currency"
  | "upsellSupport"
> & {
  defaultFare: FindFlightOffersOfferV3["upsellOption"];
  itineraryIndex: number;
  searchResultToken: string;
  flights: (Pick<FindFlightOffersFlightV3, "duration" | "key" | "stops"> & {
    segments: FindFlightOffersFlightSegmentV3[];
  })[];
};

export type FlightOfferFlight = FlightOffer["flights"][number];

export enum FlightsSortOptions {
  PRICE = "price",
}

export type Airline = {
  code: string;
  name: string;
  logoUrl: string;
};

export type FlightFilters = {
  stops: StopsOptions;
  priceRange: [number, number];
  selectedAirlines: string[];
  airlines: Airline[];
};

// TODO: rename to FlightType
export enum TripType {
  ONE_WAY = "one-way",
  ROUND_TRIP = "round-trip",
}

// TODO: Rename to more generic LocationType
export enum AirportType {
  FROM = "from",
  TO = "to",
}

export enum CabinClass {
  ANY = "ANY",
  ECONOMY = "ECONOMY",
  PREMIUM_ECONOMY = "PEREMIUM_ECONOMY",
  FIRST_CLASS = "FIRST_CLASS",
  BUSINESS = "BUSINESS_CLASS",
}

export enum StopsOptions {
  ANY = "ANY",
  DIRECT = "DIRECT",
  ONE = "UP_TO_ONE",
}

export type FlightsSortValue = SortValue<FlightsSortOptions>;

export type FlightSearchType = "quick" | "full";

export type FlightSearchCriteria = {
  tripType: TripType;
  departure_city?: string;
  destination?: string;
  travel_date: string;
  return_date?: string;
  travellers: number;
};
